<template>
  <div class="list-group-wrapper">
    <b-input
      :id="id"
      v-model="inputValue"
      v-debounce="searchDebounce"
      :state="state"
      :class="inputClass"
      :placeholder="placeholder"
      :aria-describedby="id + '-live-feedback'"
    />
    <b-form-invalid-feedback :id="id + '-live-feedback'">
      Address 1 is required
    </b-form-invalid-feedback>
    <div
      v-if="options.length > 0"
      class="list-group"
    >
      <a
        v-for="option in options"
        :key="option.id"
        class="list-group-option"
        @click="hit(option)"
      >
        <div class="d-flex justify-space-between">
          <div class="formatted-address">{{ formatAddress(option) }}</div>
          <a
            class="address-edit"
            @click.stop="editAddress(option)"
          ><i class="fa fa-external-link-alt" /></a>
          <a
            class="address-delete"
            @click.stop="deleteAddress(option)"
          ><i class="fa fa-trash-alt" /></a>
        </div>
      </a>
    </div>
    <be-create-edit-modal
      v-model="addressToEdit"
      modal-name="New Address"
      :fields="modalFields"
      :open="modalOpen"
      url="addresses"
      :edit-mode="modalEditMode"
      @modal-closed="onModalClose"
    />
  </div>
</template>

<script>
  import BeCreateEditModal from "../components/crud/BeCreateEditModal";
  import {required} from "vuelidate/lib/validators";
  export default {
    name: "AddressInput",
    components: {
      BeCreateEditModal
    },
    props: ['value', 'id', 'state', 'placeholder', 'inputClass'],
    data() {
      return {
        inputValue: '',
        options: [],
        modalFields: [],
        modalOpen: false,
        addressToEdit: null,
        modalEditMode: false
      }
    },
    watch: {
      inputValue: async function (newValue) {
        this.$emit('input', newValue);
      },
      value: function(newValue){
        this.inputValue = newValue;
      }
    },
    created() {
      this.inputValue = this.value;
      this.modalFields = [
        {
          name: "address1",
          label: "Address 1",
          type: "text",
          placeholder: "Enter address 1",
          validations: {required},
          validationError: "Address 1 is required"
        },
        {
          name: "address2",
          label: "Address 2",
          type: "text",
          placeholder: "Enter address 2",
          validations: {},
          validationError: ""
        },
        {
          name: "town",
          label: "Town",
          type: "text",
          placeholder: "Enter town",
          validations: {required},
          validationError: "Town is required"
        },
        {
          name: "postCode",
          label: "Post Code",
          type: "text",
          placeholder: "Enter post code",
          validations: {required},
          validationError: "Post code is required"
        },
      ]
    },
    mounted () {
      document.addEventListener('click', this.close)
    },
    beforeDestroy () {
      document.removeEventListener('click',this.close)
    },
    methods: {
      async searchDebounce() {
        if (!this.inputValue) {
          this.options=[]
          return;
        }
        try {
          let result = await this.$http.get(`addresses?limit=5&search=${this.inputValue}`);
          this.options = result.data.items;
        } catch (error) {
          this.handleErrorResponse(error);
        }
      },
      formatAddress(option) {
        return `${option.address1}, ${option.address2 ? option.address2 + ',' : ''} ${option.town}, ${option.postCode}`
      },
      hit(option) {
        this.options = []
        this.$emit('hit', option)
      },
      close(){
        this.options = [];
      },
      editAddress(option) {
        this.addressToEdit = option;
            this.modalEditMode = true;
            this.modalOpen = true
            this.inputValue = '';
      },
      async deleteAddress (option) {
            try{
              let confirmation = await this.$bvModal.msgBoxConfirm('Are you sure you want to delete this address?', {
                okVariant: 'danger',
                okTitle: 'Delete',
              });
              if (!confirmation) return;
              let response = await this.$http.delete(`addresses/${option.id}`);
              this.close();
              this.inputValue = '';
            }catch(error){
              this.handleErrorResponse(error);
            }
          },
      onModalClose() {
        this.modalOpen = false
        this.modalEditMode = false
        this.addressToEdit = null
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.list-group-wrapper {
  position: relative;
}

.list-group {
position: absolute;
z-index: 9000;
width: 100%;
padding-left: 12px;
padding-right: 12px;
background-color: $white;
border: 1px $border-grey solid;
border-radius: 0.25rem;
top: 38px;
box-shadow: 0px 3px 5px 0px $light-grey;

  :last-child {
    border-bottom: none;
}

}

.list-group-option {
  border-bottom: 1px $border-grey solid;
  padding-top: 2px;
  padding-bottom: 2px;
  cursor: pointer;
}

.formatted-address {
  flex-basis: 100%;
}

.address-edit {
    margin-left: 6px;
    i {
      color: $info;
    }
  }

  .address-delete {
    margin-left: 4px;

    i {
      color: $danger;
    }
  }

</style>